import * as SentryBrowser from '@sentry/browser';
import * as Sentry from '@sentry/react-native';
import { Platform } from 'react-native';

export default function logger(error: any, name?: string) {
  if (__DEV__) {
    if (error?.response) {
      console.log(error.response, name);
    } else {
      console.log(error, name);
    }
  } else {
    if (Platform.OS === 'web') {
      if (error?.response?.data) {
        SentryBrowser?.addBreadcrumb({ data: error?.response?.data });
      }
      SentryBrowser.captureException(error);
    } else {
      if (error?.response?.data) {
        Sentry?.addBreadcrumb({ data: error?.response?.data });
      }
      Sentry.captureException(error);
    }
  }
}
